import { HandHeart, Award, Clock, Gift } from "lucide-react";

const items = [
    { icon: HandHeart, title: "Handcrafted", subtitle: "Treats made with care" },
    { icon: Award, title: "Premium Quality", subtitle: "Only the best ingredients" },
    { icon: Clock, title: "Made to Order", subtitle: "Fresh, custom & delicious" },
    { icon: Gift, title: "Perfect for Any Occasion", subtitle: "Big or small" },
];

export const TrustStrip = () => {
    return (
        <div className="max-w-6xl mx-auto -mt-10 md:-mt-12 relative z-10 px-4">
            <div
                className="bg-white rounded-3xl sss-shadow px-6 py-6 md:py-8 grid grid-cols-2 md:grid-cols-4 gap-6"
                data-testid="trust-strip"
            >
                {items.map(({ icon: Icon, title, subtitle }) => (
                    <div key={title} className="flex flex-col items-center text-center gap-2">
                        <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: "var(--sss-blush)" }}>
                            <Icon size={22} className="text-[var(--sss-pink)]" strokeWidth={1.4} />
                        </div>
                        <p className="text-xs md:text-sm uppercase tracking-widest font-semibold">{title}</p>
                        <p className="text-xs text-[var(--sss-text-muted)] leading-snug">{subtitle}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
